/**
 * PortfolioPanel for a group
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Card } from 'react-bootstrap';
import Switch from 'components/interaction/Switch/index.jsx';
import messages from '../messages.js';

function PortfolioPanel(props) {
  const { portfolio, onVisible } = props;
  if (!portfolio || !portfolio.enabled) {
    return null;
  }
  const { visible } = portfolio;
  return (
    <Card>
      <Card.Header className="border-0">
        <h4 className="mb-0"><FormattedMessage {...messages.portfolio} /></h4>
      </Card.Header>
      <Card.Body>
        <p><FormattedMessage {...messages.portfolioIntro} /></p>
        <Switch value={visible} onChange={onVisible}>
          <span className="ms-2">
            <FormattedMessage {...messages.visibilityLabel} />
          </span>
        </Switch>
      </Card.Body>
    </Card>
  );
}

PortfolioPanel.propTypes = {
  portfolio: PropTypes.object,
  onVisible: PropTypes.func,
};

export default PortfolioPanel;
